// src/components/WelcomePage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Button, Typography, Box, Fade, Menu, MenuItem } from '@mui/material';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleContactClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAdminLogin = () => {
    navigate('/admin-login');
  };
  const logoUrl = process.env.PUBLIC_URL + '/logo.jpeg';
  return (
    <div className="welcome-page">
      <AppBar position="fixed" className="app-bar" elevation={0}>
        <Toolbar>
          <img src={logoUrl} alt="Logo" className="brand-logo" />
          <Typography variant="h6" component="div" className="brand-name">
          SHREE SIDDHARAMESHWAR FINANCE AND LEASING
          </Typography>
          <div className="nav-buttons">
            <Button color="inherit" onClick={handleAdminLogin}>
              Admin Login
            </Button>
            <Button color="inherit" onClick={handleContactClick}>
              Contact
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleClose}>Address: Kasgi</MenuItem>
        <MenuItem onClick={handleClose}>Phone: +91 9123456789</MenuItem>
      </Menu>
      <Fade in={true} timeout={1000}>
        <Box className="welcome-content">
          <img src={logoUrl} alt="Logo" className="welcome-logo" />
          <Typography variant="h3" component="h1" gutterBottom>
            Welcome to SHREE SIDDHARAMESHWAR FINANCE AND LEASING
          </Typography>
          <Typography variant="body1">
            Please select your login type from the top navigation.
          </Typography>
        </Box>
      </Fade>
    </div>
  );
};
export default WelcomePage;